import { createPartnerAdminApiStore } from '@/api'
import { getStrDate } from '@/utils/DateUtils'
import config from '@/config'

const apiStore = createPartnerAdminApiStore([
  {
    action: '_companyServiceComplaint',
    path: `v2/odr/partners`,
    method: 'get',
    cacheable: false
  },
  {
    action: '_productServiceComplaint',
    path: 'v2/odr/products',
    method: 'get',
    cacheable: false
  }
])

const PAGE_DATA = () => {
  return {
    pageIndex: 1,
    pageCount: 30,
    format: ''
  }
}

const SEARCH_DATA = () => {
  return {
    date: getStrDate(new Date(), '-'),
    filterMin: 1,
    order: '',
    direction: '',
    format: null
  }
}

const INIT_DATA = () => {
  return Object.assign({}, SEARCH_DATA(), PAGE_DATA())
}

export default {
  namespaced: true,
  mixins: [apiStore],
  state: {
    listParams: INIT_DATA()
  },
  actions: {
    companyServiceComplaint({ state, dispatch, commit }, params) {
      return dispatch('_companyServiceComplaint', { params: Object.assign({}, state.listParams, params) })
    },
    productServiceComplaint({ state, dispatch, commit }, params) {
      return dispatch('_productServiceComplaint', { params: Object.assign({}, state.listParams, params) })
    }
  },
  mutations: {
    SET_SEARCH_PARAMS(state, params) {
      state.listParams.date = params.date
      state.listParams.filterMin = params.filterMin
      state.listParams.order = params.order
      state.listParams.direction = params.direction
      state.listParams.beginAt = params.beginAt
      state.listParams.endAt = params.endAt
    },
    SET_PAGE_PARAMS(state, params) {
      state.listParams.pageIndex = params.pageIndex
      state.listParams.pageCount = params.pageCount
      state.listParams.format = params.format
    },
    INIT(state) {
      state.listParams = INIT_DATA()
    }
  },
  getters: {
    listParams: (state, getters) => {
      return state.listParams
    },
    productStatusData: (state, getters) => {
      return JSON.parse(JSON.stringify(config.defines.serviceComplaint.productStatusData))
    },
    productQueryTargetData: (state, getters) => {
      return JSON.parse(JSON.stringify(config.defines.serviceComplaint.productQueryTargetData))
    }
  }
}
